<template>
  <apexchart type="bar" height="600" :options="chartOptions" :series="series" />
</template>

<script>
import common from '@/utils/common'

export default {
  name: 'BarWithNegativeChart',
  props: {
    title: {
      type: String,
      default: '',
    },
    compares: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: undefined,
    }
  },
  computed: {
    series() {
      return this.data
    },
    labels() {
      return this.compares.map(e => e.doctorName)
    },
    dates() {
      return this.compares.map(
        e =>
          `${common.dateFormat(e.date.startDate)} - ${common.dateFormat(
            e.date.endDate,
          )}`,
      )
    },
    chartOptions() {
      return {
        chart: {
          stacked: true,
          toolbar: { show: false },
        },
        colors: ['#008ffb', '#bdbdbd'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%',
          },
        },
        legend: {
          fontSize: '18px',
          itemMargin: {
            vertical: 20,
          },
          markers: {
            width: 18,
            height: 18,
            radius: 18,
          },
        },
        dataLabels: {
          enabled: true,
          formatter(v) {
            return Math.abs(Math.round(v)) + '%'
          },
          style: {
            fontSize: '24px',
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        xaxis: {
          categories: this.labels,
          // min: -100,
          // max: 100,
          labels: {
            formatter(v) {
              return Math.abs(Math.round(v)) + '%'
            },
            style: {
              fontSize: '24px',
            },
            offsetY: 10,
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '24px',
            },
          },
        },
        tooltip: {
          shared: false,
          theme: 'dark',
          custom: this.genTooltipContent,
        },
        title: {
          text: this.title,
          align: 'center',
          style: {
            fontSize: '34px',
            fontWeight: 'bold',
            color: '#757575',
          },
        },
      }
    },
  },
  methods: {
    genTooltipContent({ seriesIndex, dataPointIndex }) {
      return `
        <div class="chart__tips">
          <h2 class="my-2 headline">${this.labels[dataPointIndex]}</h2>
          <h2 class="my-2 headline">${this.dates[dataPointIndex]}</h2>
          <h2 class="my-2 headline">
            大腸鏡筆數：
            <span class="chart__percent">
              ${Math.abs(this.data[seriesIndex].data[dataPointIndex])}
            </span>
            筆
          </h2>
        </div>
      `
    },
  },
}
</script>
